import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { axionsInstanceBaseApi } from '../components/network'
import { Table, Input, Row, Col, Pagination, Skeleton, Empty, Tag } from 'antd'
import CustomBreadCrumb from '../components/lib/CustomBreacCrumb'
const { Search } = Input;


type FilterType = {
  page?: number
  max?: number
  search?: string
}

const GroupMember = () => {

  const { id } = useParams()
  const [list, setList] = useState()
  const [totalCount, setTotalCount] = useState()
  const [loading, setLoading] = useState(false)
  const [filter, _setFilter] = useState<FilterType>({
    page: 1,
    max: 10,
    search: '',
  })

  const setFilter = (value: Partial<FilterType>) => {
    _setFilter({ ...filter, ...value })
  }

  const token = localStorage.getItem('imToken')
  const location = useLocation()

  const fetchMemberList = async () => {
    setLoading(true)
    try {
      const { data } = await axionsInstanceBaseApi.post('/group/get_group_member_list', { groupID: id, pagination: { pageNumber: filter.page, showNumber: 20 } }, {
        headers: { 'Token': token },
      })
      setList(data?.data?.members)
      setTotalCount(data?.data?.total)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log('ERROR:::::::::', e)
    }
  }
  useEffect(() => {
    fetchMemberList()
  }, [])


  const onSearchMember = () => {

  }

  const columns = [
    {
      title: 'Зураг',
      dataIndex: 'faceURL',
      key: 'faceURL',
      render: (faceURL: string) => {
        return (
          <React.Fragment>
            <img className='h-11 w-11 object-cover rounded-md outline-none border-none bg-gray-200' alt='faceUrl' src={faceURL} />
          </React.Fragment>
        )
      }
    },
    {
      title: 'Нэр',
      dataIndex: 'nickname',
      key: 'nickname',
    },
    {
      title: 'roleLevel',
      dataIndex: 'roleLevel',
      key: 'roleLevel',
      render: (role: number) => {

        let text = 'member';
        let color = 'blue';

        if (role === 100) {
          text = 'Эзэмшигч';
          color = 'red';
        } else if (role === 60) {
          text = 'Зохицуулагч';
          color = 'green';
        } else if (role === 20) {
          text = 'Гишүүн';
          color = 'blue';
        }

        return <Tag color={color}>{text}</Tag>;
      }
    },
    {
      title: 'ID',
      dataIndex: 'userID',
      key: 'userID',
    },
  ]


  const onPageChange = (page: number) => {

    setFilter({ page })
  }

  const onShowSizeChange = (current: any, pageSize: any) => {
    setFilter({ max: pageSize })
  }
  const showTotal = (total: number, range: number[]) => {
    return (
      <>
        Нийт: <span>{total}</span>
      </>
    )
  }

  return (
    <div>
      <CustomBreadCrumb item={[{ link: '/groupList', name: 'Грөүп жагсаалт' }, { link: location.pathname, name: 'Грөүп гишүүд' }]} />
      <Row className='mb-6'>
        <Col span={4}>
          <Search placeholder="Нэрээр хайх" onSearch={onSearchMember} enterButton />
        </Col>
      </Row>
      <Table
        dataSource={list}
        columns={columns}
        locale={{
          emptyText: loading ? <Skeleton active={true} /> : <Empty />
        }}
        pagination={false}
      />
      <div className='flex items-center justify-end my-4'>
        <Pagination
          pageSize={filter.max}
          total={totalCount}
          current={filter.page}
          onChange={onPageChange}
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          showTotal={showTotal}
        />
      </div>
    </div>
  )
}

export default GroupMember